import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'BONO 1: RUTAS DE EMERGENCIA S.O.S',
    desc: 'Brote repentino, reacción alérgica, quemadura por ácido. Tienes un evento en 48 horas. Este bono te dice exactamente qué hacer, paso a paso, para salvar tu piel cuando todo falla.',
    value: '9.99€'
  }, {
    num: '02',
    title: 'BONO 2: EL BRILLO INTERNO',
    desc: 'Colágeno, omega 3, zinc, vitamina C oral, probióticos. Qué tomar, cuándo, en qué dosis y qué marcas disponibles en España realmente funcionan para potenciar tu piel desde dentro.',
    value: '9.99€'
  }, {
    num: '03',
    title: 'BONO 3: EL PLANIFICADOR DE AHORRO',
    desc: 'Nunca más compres un producto por impulso. Este planificador te dice exactamente qué necesitas, cuándo comprarlo y cuánto gastar al mes para mantener tu rutina optimizada.',
    value: '7.99€'
  }];
  return <Section data-id="element-71">
      <div className="text-center mb-12" data-id="element-72">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-4 text-brand-title" data-id="element-73">
          🎁 MÁS LOS 3 BONOS ESTRATÉGICOS
        </h2>
        <span className="inline-block bg-brand-cta text-white font-heading font-bold px-4 py-1 rounded-full text-sm tracking-wider" data-id="element-74">
          Incluidos en todas las ofertas — sin coste extra
        </span>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-75">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-neutral-200 rounded-2xl p-8 relative overflow-hidden group hover:border-brand-cta/30 transition-colors shadow-sm" data-id="element-76">
            <div className="absolute -right-4 -top-4 font-display text-8xl font-black text-brand-bgAlt opacity-50 group-hover:text-brand-subtitle/10 transition-colors" data-id="element-77">
              {bonus.num}
            </div>
            <div className="relative z-10" data-id="element-78">
              <div className="text-2xl mb-4" data-id="element-79">🎁</div>
              <h3 className="font-heading text-xl font-bold text-brand-title mb-3" data-id="element-80">
                {bonus.title}
              </h3>
              <p className="font-body text-brand-text leading-relaxed mb-6 text-sm" data-id="element-81">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-82">
                <span className="font-body text-neutral-400 line-through text-lg" data-id="element-83">
                  Valor: {bonus.value}
                </span>
                <span className="font-heading text-brand-cta font-bold text-xl" data-id="element-84">
                  → GRATIS
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-brand-bgAlt border border-brand-subtitle/20 rounded-2xl p-6 max-w-md mx-auto text-center flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-85">
        <div data-id="element-86">
          <div className="font-body text-brand-subtitle text-sm mb-1 font-medium" data-id="element-87">
            Valor total de los 3 Bonos
          </div>
          <div className="font-heading text-2xl font-bold text-neutral-400 line-through" data-id="element-88">
            27.97€
          </div>
        </div>
        <div className="hidden md:block text-brand-subtitle text-3xl" data-id="element-89">→</div>
        <div data-id="element-90">
          <div className="font-heading text-3xl font-bold text-brand-cta flex items-center gap-2" data-id="element-91">
            🎁 GRATIS
          </div>
          <div className="font-body text-brand-title text-xs mt-1 font-medium" data-id="element-92">
            Solo en este lanzamiento
          </div>
        </div>
      </div>
    </Section>;
}